// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg-color: #1e192e;
  --primary-color: #69c9ca;
  --secondary-color: #41aaa5;
  --third-color: #38304c;
  --primary-text: #e2e1e4;
  --secondary-text: #8e8a97;
  --green-color: #2ecc71;
  --red-color: #d1495b;
  --roboto-thin: 100;
  --roboto-light: 300;
  --roboto-regular: 400;
  --roboto-medium: 500;
  --roboto-bold: 700;
  --roboto-black: 900;
}

* {
  margin: 0;
}

body {
  height: 100%;
  align-items: center;
  background-color: var(--bg-color);
  display: flex;
  justify-content: center;
  margin: 0px;
  overflow: auto;
  padding: 0px;
  color: var(--primary-text);
  font-family: "Roboto", sans-serif;
}

#root {
  width: 100%;
  text-align: center;
}

::selection {
  color: var(--primary-text);
  background: var(--secondary-color);
}

::-webkit-scrollbar {
  width: 12px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: var(--secondary-color);
  border-radius: 6px;
  border: 3px solid transparent;
}

::-webkit-scrollbar-thumb:hover {
  background-color: var(--secondary-text);
}

html {
  scrollbar-width: thin;
  scrollbar-color: var(--secondary-color) transparent;
}

::-webkit-scrollbar-button {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAOA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,aAAa;AACf","sourcesContent":[":root {\r\n  --bg-color: #1e192e;\r\n  --primary-color: #69c9ca;\r\n  --secondary-color: #41aaa5;\r\n  --third-color: #38304c;\r\n  --primary-text: #e2e1e4;\r\n  --secondary-text: #8e8a97;\r\n  --green-color: #2ecc71;\r\n  --red-color: #d1495b;\r\n  --roboto-thin: 100;\r\n  --roboto-light: 300;\r\n  --roboto-regular: 400;\r\n  --roboto-medium: 500;\r\n  --roboto-bold: 700;\r\n  --roboto-black: 900;\r\n}\r\n\r\n* {\r\n  margin: 0;\r\n}\r\n\r\nbody {\r\n  height: 100%;\r\n  align-items: center;\r\n  background-color: var(--bg-color);\r\n  display: flex;\r\n  justify-content: center;\r\n  margin: 0px;\r\n  overflow: auto;\r\n  padding: 0px;\r\n  color: var(--primary-text);\r\n  font-family: \"Roboto\", sans-serif;\r\n}\r\n\r\n#root {\r\n  width: 100%;\r\n  text-align: center;\r\n}\r\n\r\n::-moz-selection {\r\n  color: var(--primary-text);\r\n  background: var(--secondary-color);\r\n}\r\n\r\n::selection {\r\n  color: var(--primary-text);\r\n  background: var(--secondary-color);\r\n}\r\n\r\n::-webkit-scrollbar {\r\n  width: 12px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background-color: var(--secondary-color);\r\n  border-radius: 6px;\r\n  border: 3px solid transparent;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background-color: var(--secondary-text);\r\n}\r\n\r\nhtml {\r\n  scrollbar-width: thin;\r\n  scrollbar-color: var(--secondary-color) transparent;\r\n}\r\n\r\n::-webkit-scrollbar-button {\r\n  display: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
